Object.defineProperty(exports, "__esModule", { value: true });
exports.pagePreviewReducer = void 0;
exports.pagePreviewReducer = (state, action) => {
    switch (action.type) {
        case 'SET_PREVIEW_PAGE':
            return Object.assign(Object.assign({}, state), { previewPage: action.previewPage });
        case 'SET_PREVIEW_MODE':
            return Object.assign(Object.assign({}, state), { inPreviewMode: action.mode });
        case 'SET_IS_FETCHING':
            return Object.assign(Object.assign({}, state), { isFetching: action.isFetching });
        default:
            throw new Error();
    }
};
//# sourceMappingURL=page-preview-reducer.js.map